import { useState } from "react";

import { db, storage } from "../../../../util/firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Button, Modal, ModalBody, Input } from "reactstrap";
import Swal from "sweetalert2";

function AdminAddBannerPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [image, setImage] = useState();

  const addBanner = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "homePageBanners"), {
        uid: uuidv4(),
        url: image,
        dateAdded: new Date().toISOString(),
      });

      Swal.fire({
        text: "Banner added successfully",
        icon: "success",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      }).then(() => {
        navigate(-1);
      });

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [newArticleImage, setNewArticleImage] = useState();
  const [newArticleImagePreview, setNewArticleImagePreview] = useState();
  const [changeRewardImageModalIsOpen, setChangeRewardImageModalIsOpen] =
    useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const toggleChangeRewardImageModal = () => {
    setChangeRewardImageModalIsOpen(!changeRewardImageModalIsOpen);
  };

  const handleChangeNewArticleImage = (e) => {
    setNewArticleImage(e.target.files[0]);
    setNewArticleImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewArticleImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewArticleImage = async () => {
    setIsModalLoading(true);

    const storageRef = ref(storage, `assets/heros/${newArticleImage.name}`);
    await uploadBytesResumable(storageRef, newArticleImage).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        setImage(downloadURL);
        setIsModalLoading(false);
        toggleChangeRewardImageModal();
      });
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        ADD BANNER
      </h1>
      <div>
        <div id="adminNewsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button
              onClick={toggleChangeRewardImageModal}
              className="primaryBtn"
            >
              ADD
            </Button>
            <Modal
              id="changeNewsArticleImageModal"
              isOpen={changeRewardImageModalIsOpen}
              toggle={toggleChangeRewardImageModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleChangeRewardImageModal} />
                </div>
                <div>
                  <h1>ADD IMAGE</h1>
                  {isModalLoading ? (
                    <div
                      style={{
                        height: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BarLoader color="#005EE1" />
                    </div>
                  ) : (
                    <div style={{ marginTop: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <img
                          alt="articleImage"
                          src={
                            newArticleImagePreview
                              ? newArticleImagePreview
                              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                          }
                          style={{ width: 651.4, height: "auto" }}
                        />
                      </div>
                      <Input
                        id="selectImage"
                        type="file"
                        className="mainInput"
                        accept="image/*"
                        onChange={handleChangeNewArticleImage}
                        style={{ display: "none" }}
                      />
                      <Button
                        onClick={selectNewArticleImage}
                        className="secondaryBtn"
                        style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                      >
                        {newArticleImage?.name
                          ? newArticleImage.name
                          : "CHOOSE IMAGE (1,900x1,500px)"}
                      </Button>
                      <Button
                        onClick={handleUploadNewArticleImage}
                        disabled={!newArticleImage?.name}
                        className="primaryBtn"
                      >
                        ADD
                      </Button>
                    </div>
                  )}
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <Button
          onClick={addBanner}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={!image}
        >
          ADD BANNER
        </Button>
      </div>
    </div>
  );
}

export default AdminAddBannerPage;
